import LazyLoadingWrapping from './LazyLoadingWrapping'
// export { default as Dashboard } from "./Dashboard/Dashboard";
// export { default as LogTable } from "../common/LogTable";
// export { default as CustomerCareTasksTable } from "./Tasks/TasksTable/CustomerCareTasksTable";
// export { default as InstallationTasksTable } from "./Tasks/TasksTable/InstallationTasksTable";
// export { default as TasksTable } from "./Tasks/TasksTable/TasksTable";
// export { default as Tasks } from "./Tasks/Tasks";
// export { default as TaskSummaryDashboard } from "./Dashboard/TaskSummaryDashboard";
// export { default as CustomerCarTaskReport } from "./Tasks/TasksTable/CustomerCarTaskReport";
// export { default as Users } from "./Users/Users";
// export { default as Departmant } from "./Department/Department";
// export { default as TaskType } from "./TaskType/TaskType";
// export { default as RequestType } from "./RequestType/RequestType";
// export { default as Complain } from "./Complain/Complain";
// export { default as MizanListStatus } from "./MizanListStatus/MizanListStatus";
// export { default as DefaultSetting } from "./Setting/DefaultSetting";
// export { default as UnavailableResources } from "./Planning/UnavailableResources";
// export { default as DailyPlan } from "./Planning/DailyPlan";
// export { default as CreateMission } from "./Planning/CreateMission";
// export { default as MissionsTable } from "./Missions/MissionsTable";
// export { default as MissionDetails } from "./Missions/MissionDetails";
// export { default as Notification } from "./Notifications/Notification";
// export { default as Profile } from "./Profile/Profile";
// export { default as LeaveRequest } from "./LeaveRequests/LeaveRequest";
// export { default as InventoryRequest } from "./InventoryRequests/InventoryRequest";
// export { default as UserOverTime } from "./UserOverTimes/UserOverTime";
// export { default as CarInspections } from "./CarInspections/CarInspections";
// export { default as SubMissionOverTime } from "./SubMissionOverTime/SubMissionOverTime";
// export { default as CarInspectionsQuestions } from "./CarInspections/CarInspectionsQuestions";
// export { default as CarInspectionsCategories } from "./CarInspections/CarInspectionsCategories";
// export { default as DetialsTaskEdit2 } from "./Tasks/DetialsTaskEdit2";
// export { default as File } from "./Files/File";
// export { default as Classification } from "./Classifications/Classification";
// export { default as ClassificationLevel1 } from "./ClassificationsLevel1/ClassificationLevel1";
// export { default as ClassificationLevel2 } from "./ClassificationsLevel2/ClassificationLevel2";
// export { default as ClassificationLevel3 } from "./ClassificationsLevel3/ClassificationLevel3";
// export { default as ClassificationLevel4 } from "./ClassificationsLevel4/ClassificationLevel4";




// Lazy load all components
export const Dashboard = LazyLoadingWrapping(() => import("./Dashboard/Dashboard"));
export const LogTable = LazyLoadingWrapping(() => import("../common/LogTable"));
export const CustomerCareTasksTable = LazyLoadingWrapping(() =>
  import("./Tasks/TasksTable/CustomerCareTasksTable")
);
export const InstallationTasksTable = LazyLoadingWrapping(() =>
  import("./Tasks/TasksTable/InstallationTasksTable")
);
export const TasksTable = LazyLoadingWrapping(() => import("./Tasks/TasksTable/TasksTable"));
export const Tasks = LazyLoadingWrapping(() => import("./Tasks/Tasks"));
export const TaskSummaryDashboard = LazyLoadingWrapping(() =>
  import("./Dashboard/TaskSummaryDashboard")
);
export const CustomerCarTaskReport = LazyLoadingWrapping(() =>
  import("./Tasks/TasksTable/CustomerCarTaskReport")
);
export const Users = LazyLoadingWrapping(() => import("./Users/Users"));
export const Departmant = LazyLoadingWrapping(() => import("./Department/Department"));
export const TaskType = LazyLoadingWrapping(() => import("./TaskType/TaskType"));
export const RequestType = LazyLoadingWrapping(() => import("./RequestType/RequestType"));
export const Complain = LazyLoadingWrapping(() => import("./Complain/Complain"));
export const MizanListStatus = LazyLoadingWrapping(() =>
  import("./MizanListStatus/MizanListStatus")
);
export const DefaultSetting = LazyLoadingWrapping(() =>
  import("./Setting/DefaultSetting")
);
export const UnavailableResources = LazyLoadingWrapping(() =>
  import("./Planning/UnavailableResources")
);
export const DailyPlan = LazyLoadingWrapping(() => import("./Planning/DailyPlan"));
export const CreateMission = LazyLoadingWrapping(() =>
  import("./Planning/CreateMission")
);
export const MissionsTable = LazyLoadingWrapping(() => import("./Missions/MissionsTable"));
export const MissionDetails = LazyLoadingWrapping(() =>
  import("./Missions/MissionDetails")
);
export const Notification = LazyLoadingWrapping(() => import("./Notifications/Notification"));
export const Profile = LazyLoadingWrapping(() => import("./Profile/Profile"));
export const LeaveRequest = LazyLoadingWrapping(() =>
  import("./LeaveRequests/LeaveRequest")
);
export const InventoryRequest = LazyLoadingWrapping(() =>
  import("./InventoryRequests/InventoryRequest")
);
export const UserOverTime = LazyLoadingWrapping(() =>
  import("./UserOverTimes/UserOverTime")
);
export const CarInspections = LazyLoadingWrapping(() =>
  import("./CarInspections/CarInspections")
);
export const SubMissionOverTime = LazyLoadingWrapping(() =>
  import("./SubMissionOverTime/SubMissionOverTime")
);
export const CarInspectionsQuestions = LazyLoadingWrapping(() =>
  import("./CarInspections/CarInspectionsQuestions")
);
export const CarInspectionsCategories = LazyLoadingWrapping(() =>
  import("./CarInspections/CarInspectionsCategories")
);
export const DetialsTaskEdit2 = LazyLoadingWrapping(() =>
  import("./Tasks/DetialsTaskEdit2")
);
export const File = LazyLoadingWrapping(() => import("./Files/File"));
export const Classification = LazyLoadingWrapping(() => import("./Classifications/Classification"));
export const ClassificationLevel1 = LazyLoadingWrapping(() =>
  import("./ClassificationsLevel1/ClassificationLevel1")
);
export const ClassificationLevel2 = LazyLoadingWrapping(() =>
  import("./ClassificationsLevel2/ClassificationLevel2")
);
export const ClassificationLevel3 = LazyLoadingWrapping(() =>
  import("./ClassificationsLevel3/ClassificationLevel3")
);
export const ClassificationLevel4 = LazyLoadingWrapping(() =>
  import("./ClassificationsLevel4/ClassificationLevel4")
);

export const VehicleMaster = LazyLoadingWrapping(() =>
  import("./CarInspections/VehicleMaster")
);
export const ClassificationTreeView = LazyLoadingWrapping(() =>
  import("./ClassificationsTreeView/ClassificationTreeView")
);
export const DNDMissions = LazyLoadingWrapping(() =>
  import("./DNDMissions/DNDMissions")
);
export const GroupsComponent = LazyLoadingWrapping(() =>
  import("./GroupsComponent/GroupsComponent")
);
export const MissionAndSubMissionPage = LazyLoadingWrapping(() =>
  import("./Missions/MissionAndSubMissionPage")
);
export const UpdateContent = LazyLoadingWrapping(() =>
  import("./UpdateContent/UpdateContent")
);
export const ImageSubmissionType = LazyLoadingWrapping(() =>
  import("./ImageSubmissionType/ImageSubmissionType")
);
export const SubmissionImageType = LazyLoadingWrapping(() =>
  import("./SubmissionImageTypes/SubmissionImageType")
);
export const SubmissionType = LazyLoadingWrapping(() =>
  import("./SubmissionTypes/SubmissionType")
);
export const FileManager = LazyLoadingWrapping(() =>
  import("./FileManager/FileManager")
);
export const FinancesTabs = LazyLoadingWrapping(() =>
  import("./Finances/FinancesTabs")
);
export const Finances = LazyLoadingWrapping(() =>
  import("./Finances/Finances")
);
export const FinanceType = LazyLoadingWrapping(() =>
  import("./FinanceType/FinanceType")
);
export const FinanceTaskDetails = LazyLoadingWrapping(() =>
  import("./Finances/FinanceTaskDetails")
);
export const UnitsTransfer = LazyLoadingWrapping(() =>
  import("./UnitsTransfer/UnitsTransfer")
);
export const UnitsTransferTabs = LazyLoadingWrapping(() =>
  import("./UnitsTransfer/UnitsTransferTabs")
);
export const Attendances = LazyLoadingWrapping(() =>
  import("./Attendances/Attendances")
);
export const TransferNotification = LazyLoadingWrapping(() =>
  import("./TransferNotification/TransferNotification")
);
export const WarshaPlanning = LazyLoadingWrapping(() =>
  import("./WarshaPlanning/WarshaPlanning")
);
export { default as Login } from "./Login/NewLogin";
// export { default as Login } from "./Login/Login";

